export * from './table.config';
